import {computed, Directive, inject, input, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {FormComponent} from './form.component';

@Directive()
export abstract class SubTableBaseComponent<T> extends FormComponent implements OnInit {
	items = input<T[]>([]);
	requiresAtLeastOneItem = input<boolean>(true);

	manuallyAssignItems = computed<T[]>(() => []);

	form: FormGroup;

	protected fb = inject(FormBuilder);

	get itemsForm(): FormArray {
		return this.form.get('items') as FormArray;
	}

	ngOnInit() {
		this.beforeInit();

		const items = [...(this.items() || []), ...this.manuallyAssignItems()];

		if (this.requiresAtLeastOneItem() && items.length === 0) {
			items.push({} as T);
		}

		this.form = this.fb.group({
			items: this.fb.array(items.map(i => this.createLineGroup(i))),
		});
	}

	addLine() {
		this.itemsForm.push(this.createLineGroup());
	}

	removeLine(index: number) {
		this.itemsForm.removeAt(index);
	}

	getData(): T[] {
		return this.itemsForm.getRawValue().map((item: any) => {
			return {
				...this.convertLineToData(item),
				fid: undefined,
			};
		});
	}

	protected beforeInit() {}

	protected convertLineToData(item: any): T {
		return item;
	}

	protected createFrontendID(): number {
		return Math.floor(Math.random() * 999_999);
	}

	protected onInvalidForm() {}

	protected resetInvalidForm() {}

	protected abstract createLineGroup(item?: T): FormGroup;
}
